// extracted by mini-css-extract-plugin
export default {"main":"Tile_main__fwKNi","title":"Tile_title__-ewNb","children":"Tile_children__QNMq8"};